const AUTH_ROUTES = [
    "/login",
    "/signup",
    "/forgot-password",
    "/complete-login",
    "/complete-signup",
    "/disable-2fa",
    "/enable-2fa",
    "/request-signup",
    "/update-forgotten-password",
];

/** Routes the global Command panel must never appear on — auth pages have no
 * authenticated session to back it, and super-admin is a separate admin area. */
export function isCommandPanelDisabledRoute(pathname: string | null | undefined): boolean {
    if (!pathname) return false;
    if (pathname.startsWith("/super-admin")) return true;
    return AUTH_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`));
}
